// extracted by mini-css-extract-plugin
export default {"pop_up":"styles_pop_up__2hSV9","block":"styles_block__6daV9","block_small":"styles_block_small__kV9jU","block_markets":"styles_block_markets__Ir0FD"};